module.exports = __webpack_public_path__ + "img/symbol_herzschloss@2x.3181662.jpg";